import $ from "jquery";
import { getConfig, getContent, getMeta, getDynData } from "../../scripts/general_functions.js";

export default function(client) {

    const config = getConfig();

    getContent(config.footer).done(function(data) {

        let meta = getMeta(data);

        let dyndata = getDynData(meta);

        // let phone = dyndata["telefonnummer"];
        // let email = dyndata["e_post"];
        // let open = dyndata["apningstid"];
        // let visit = dyndata["besoksadresse"];
        // let post = dyndata["postadresse"];
        let text1 = dyndata["fritekst_venstre"];
        let text3 = dyndata["fritekst_senter"];
        let text2 = dyndata["fritekst_hoyre"];
        // let textFeil = dyndata["testfeil"];

        /*let kontakt;
        if (phone || email || visit || post) {
            kontakt = `
                
                <h2>Kontaktinformasjon</h2>`;
        }
        if (phone) {
            let openhour = ``;
            if (open) {
                openhour = open;
            }
            kontakt += `
                <p>
                    <span class="footer__icon"><i class="budlight-call"></i></span> <a href="tel:${phone}">${phone}</a> ${openhour}
                </p>`;
        }
        if (email) {
            kontakt += `
                <p>
                    <span class="footer__icon"><i class="budlight-at-symbol"></i></span> <a href="mailto:${email}">Send e-post</a> 
                </p>`;
        }
        if (visit) {
            kontakt += `
                <p>
                    <span class="footer__icon"><i class="budlight-location-pin"></i></span> ${visit}</a> 
                </p>`;
        }
        if (visit) {
            kontakt += `
                <p>
                    <span class="footer__icon"><i class="budlight-email"></i></span> ${post}</a> 
                </p>`;
        }*/

        let leftcolumn = ``;
        if (text1) {
            leftcolumn = text1;
        }
        let rightcolumn = ``;
        if (text2) {
            rightcolumn = text2;
        }
        let centercolumn = ``;
        if (text3) {
            centercolumn = text3;
        }
        //${kontakt}




        const footerHtml = `
    <div class="footer__pre">
    </div>
    <div class="totop__container container">
        <div class="row">
            <div class="col ">
                <a href="javascript:window.scrollTo(0,0);" aria-label="Til toppen" class="totop__link d-table"><span class="budlight-arrow-top totop__icon d-table-cell align-middle"></a>
            </div>
        </div>
    </div>
    <div class="footer--container">
        <div class="footer__post">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <div class="footer--container--inner footer__content">
                            <div class="row">
                                <div class="col-sm-4 col-md-4 ">
                                    
                                    ${leftcolumn}
                                </div>
                                <div class="col-sm-4">
                                
                                    ${centercolumn}
        
                                </div>
                                <div class="col-sm-4">
                                
                                    ${rightcolumn}
        
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>


    

        `;



        $("#footer").append(footerHtml);

        let analytics = '';

        // console.log("client",config);

        if (config.analytics) {
            analytics = config.analytics;


            let gscript = `
        
                
            <script async src="https://www.googletagmanager.com/gtag/js?id=${analytics}"></script>
            <script>
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());
            
              gtag('config', '${analytics}');
            </script>
        
        `

            $("body").append(gscript);


        }




    });

}
